<template>
    <div>
        <div class="shadow_box rounded-lg p-6 relative flex flex-col">
            <p class="title"><strong>Pesquisa</strong></p>
            <form class="mt-1 w-full" @submit.prevent="reloadTable">
                <div class="flex flex-wrap mb-4 px-4">
                    <multi-select-input
                        v-model="filters.MarketProvider.sales_promoter"
                        :multiple="true"
                        :options="options.salesPromoterSearch"
                        class="lg:pr-6 w-full lg:w-1/4"
                        label="Promotor"
                    />

                    <multi-select-input
                        v-model="filters.MarketProvider.provider"
                        :multiple="true"
                        :options="options.providerSearch"
                        class="lg:pr-6 w-full lg:w-1/4"
                        label="Fornecedor"
                    />

                    <multi-select-input
                        v-model="filters.MarketProvider.brand"
                        :multiple="true"
                        :options="options.brandSearch"
                        class="lg:pr-6 w-full lg:w-1/4"
                        label="Marca"
                    />

                    <multi-select-input
                        v-model="filters.MarketProvider.products"
                        :multiple="true"
                        :options="options.productSearch"
                        class="lg:pr-6 w-full lg:w-1/4"
                        label="Produtos"
                    />
                </div>
                <div class="flex flex-shrink-0 flex-wrap items-center justify-start p-4 rounded-b-md">
                    <button
                        class="btn-purple px-6 py-2.5 text-white font-roboto font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-gray-700 hover:shadow-lg focus:bg-gray-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-gray-800 active:shadow-lg transition duration-150 ease-in-out">
                        <font-awesome-icon icon="fa-magnifying-glass" class="text-white text-sm mr-0 lg:mr-2" />
                        Pesquisar
                    </button>
                    <button class="btn flex items-center text-purple-100 font-roboto font-medium
                px-6 py-2.5 text-xs leading-tight uppercase ml-1 border-solid border-2 border-purple-100"
                        @click="clearSearch">
                        <font-awesome-icon icon="fa-eraser" class="text-purple text-sm mr-0 lg:mr-2" />
                        Limpar
                    </button>
                </div>
            </form>
        </div>

        <Head title="Gerenciar Fornecedores" />
        <div class="shadow_box rounded-lg p-6 mt-4">
            <h1 class="mb-6 text-2xl text-gray-777 font-roboto uppercase">
                <Link :href="'/market_network'">
                <span class="whitespace-nowrap overflow-hidden">Rede:{{ market.name }}</span>
                </Link><br>
                Gerenciar Fornecedores
            </h1>
            <data-table v-if="loadTable" v-model:columns="columns" :route="'/market_provider/list/' + market.id"
                :query="getQuery" 
                no-data-label="Nenhuma rede cadastrada"
                no-result-label="Nenhuma rede encontrada">
                <template #table.cell.content.market="{ value, row }">
                    <div class="place-self-center grid-cols-2 gap-4">
                        <span class="flex items-center justify-center text-sm">
                            <Link :href="'market/' + row.id" class="rounded p-2 bg-purple-100 text-white">
                            Ver Lojas<font-awesome-icon icon="fa-solid fa-angle-right" class="pl-2" />
                            </Link>
                        </span>
                    </div>
                </template>
                <template #table.cell.content.provider="{ value, row }">
                    <div class="place-self-center grid-cols-2 gap-4">
                        <span class="flex items-center justify-center text-sm">
                            <Link :href="'/provider_brand/' + row.id + '/' + market.id"
                                class="rounded p-2 bg-purple-100 text-white">
                            Gerenciar Marcas<font-awesome-icon icon="fa-solid fa-angle-right" class="pl-2" />
                            </Link>
                        </span>
                    </div>
                </template>
                <template #table.cell.content.actions="{ value, row }">
                    <div class="inline-grid grid-cols-2 gap-4 ">
                        <span @click="openModalConfirmDelete(row)"
                            class="bg-red_delete text-white rounded p-2 cursor-pointer text-sm">
                            <font-awesome-icon icon="fa-trash-can" class="text-white pr-2" />Excluir
                        </span>
                    </div>
                </template>
                <template #grid.content.body.actions="{ value, row }">
                    <div class="inline-grid grid-cols-2 gap-4 ">
                        <span @click="openModalConfirmDelete(row)"
                            class="bg-red_delete text-white rounded p-2 cursor-pointer text-sm">
                            <font-awesome-icon icon="fa-trash-can" class="text-white text-lg pr-2" />Excluir
                        </span>
                    </div>
                </template>

                <template #after.reload-button>
                    <button class="flex items-end font-roboto font-medium btn-purple uppercase"
                        @click.prevent="openModalEdit({})">
                        <font-awesome-icon icon="fa-plus" class="text-white text-lg mr-0 lg:mr-2" /><span
                            class="hidden lg:block">
                            Adicionar Fornecedor à Unidade</span>
                    </button>
                </template>
            </data-table>
        </div>
        <modal-delete ref="modalDelete" @confirm="reloadTable"></modal-delete>
        <modal-edit ref="modalEdit" title="Fornecedor" url="market_provider" @submitForm="reloadTable">
            <template #form="{ item }">
                <select-input v-model="item.provider_id" :error="item.errors.provider_id" class="lg:pr-6 w-full lg:w-1/3"
                    label="Fornecedor">
                    <option :value="null" />
                    <option v-for="(value, name, index) in provider_options" :key="name" :value="name">{{ value }}
                    </option>
                </select-input>
            </template>
        </modal-edit>
    </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import LoadingButton from '@/Shared/LoadingButton'
import ModalDelete from '@/Shared/ModalDelete'
import ModalEdit from '@/Shared/ModalEdit'
import TextInput from '@/Shared/TextInput'
import DataTable from '@/Shared/DataTable'
import SelectInput from '@/Shared/SelectInput'
import MultiSelectInput from '@/Shared/MultiSelectInput'


import { useMemorizeFilters } from '@/Mixins/MemorizeFilters'
import { getFiltersMixin } from '@/Mixins/GetFilters'

export default {
    components: {
        Head,
        LoadingButton,
        ModalDelete,
        ModalEdit,
        TextInput,
        DataTable,
        SelectInput,
        MultiSelectInput,
        Link,
    },

    props: {
        provider_options: Object,
        market: Object,
    },
    
    layout: Layout,
    mixins: [getFiltersMixin],

    data () {
        return {
            loadTable: true,

            options: {
                salesPromoterSearch: [],
                marketNetworkSearch: [],
                marketSearch: [],
                providerSearch: [],
                brandSearch: [],
                productSearch: [],
            },

            columns: [
                {
                    uniqid: 'provider_name',
                    label: 'Nome do Fornecedorr',
                    field: 'name',
                    visible: true,
                    sortable: false,
                    sortOrder: 'asc',
                    classes: 'px-4 py-3 border-b text-sm',
                    headerClass: 'p-4 text-left',
                },
                {
                    uniqid: 'provider',
                    label: 'Marcas',
                    field: 'id',
                    visible: true,
                    align: 'center',
                    classes: 'py-3 border-b',
                    headerClass: 'p-4',
                },
                {
                    uniqid: 'actions',
                    label: 'Ações',
                    field: 'id',
                    visible: true,
                    align: 'center',
                    classes: 'py-3 border-b',
                    headerClass: 'p-4',
                },
            ],
        }
    },

    methods: {
        openModalConfirmDelete (item) {
            this.$refs.modalDelete.openModalDelete(item, `/market_network/remove-provider/${item.pivot.market_id}/${item.pivot.provider_id}`, `Deseja realmente excluir a redeaaa ${item.name}?`);
        },
        openModalEdit (item) {
            this.$refs.modalEdit.openModalEdit({
                id: item.id,
                provider_id: item.provider_id,
                market_id: this.market.id,
                errors: {}
            });
        },
        reloadTable () {
            this.loadTable = false;
            setTimeout(() => this.loadTable = true, 10);
        },
        clearSearch () {
            this.clearFilters()
            this.reloadTable()
        },
    },

    watch: {
        'filters.MarketProvider': {
            handler() {
                this.getFiltersFromAPI()
            },
            deep: true,
        }
    },

    computed: {
        getQuery() {
            return Object.entries( this.getFilters() ).map( ( [key, val] ) => `search2[${key}]=${val}` ).join( '&' )
        },
    },

    setup() {
        const { filtersStore, setFiltersComponent, getFiltersComponent, clearFiltersComponent } = useMemorizeFilters()

        setFiltersComponent( 'MarketProvider' )

        const clearFilters = () => clearFiltersComponent( 'MarketProvider' )
        const getFilters = () => getFiltersComponent( 'MarketProvider' )

        return { 
            getFilters,
            clearFilters, 
            filters: filtersStore.filters
        }
    }
}
</script>
